module.exports = function(ngModule) {
  ngModule.config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
    $stateProvider.state('onsite', {
      url: "/onsite",
      template: require('./onsite.html'),
      controller: require('./controller.js'),
      controllerAs: 'vm'
    });
  }])
}